export default "__VITE_ASSET__10640420__"